/* eslint-disable */
<template>
  <div class="board-box" style="width: 100vw; height: 100vh">
    <!-- 上传图片 -->
    <input
      type="file"
      accept="image/*"
      id="sketchpad-upload"
      ref="sketchpadUpload"
      @change="uploadImg($event)"
    />
    <!-- 工具列表 -->
    <ul
      style="margin: 0; padding: 0"
      class="tool-box toolList"
      :class="{
        'tool-box--left': placement === 'left',
        'tool-box--top': placement === 'top',
        'tool-box--right': placement === 'right',
        'tool-box--bottom': placement === 'bottom',
      }"
    >
      <li
        v-for="item in tools"
        :key="item.type"
        class="tool-con"
        :class="{ active: toolType === item.type }"
        @click="changeTool(item.type)"
      >
        <label
          class="tool-con"
          style="width: 100%; height: 100%"
          for="sketchpad-upload"
          v-if="item.type === 'upload'"
        >
          <i
            v-if="item.type === 'upload'"
            class="iconfont"
            :class="item.icon"
          ></i>
          <span style="font-size: 8px; display: block">{{ item.name }}</span>
        </label>
        <i class="iconfont" v-else :class="item.icon"></i>
        <span
          v-if="item.type != 'upload'"
          style="font-size: 8px; display: block"
          >{{ item.name }}</span
        >
      </li>
    </ul>
    <!-- 画布 -->

    <canvas id="myCanvas" ref="myCanvas"></canvas>
    <div
      v-show="slideShow"
      class="slide-minwidtg"
      style="position: fixed; bottom: 15px; left: 51vw"
    >
      <p style="font-size: 8px; text-align: center; margin-top: 21px">
        图片缩放
      </p>
      <div
        style="
          display: flex;
          align-items: flex-end;
          justify-content: space-around;
        "
      >
        <i class="el-icon-zoom-out" @click="less()"></i>
        <el-slider
          tooltip-class="toolTip"
          style="
            width: 100px;
            height: 17px;
            margin: 10px;
            margin-top: 0;
            margin-left: 20px;
            margin-right: 20px;
          "
          :min="10"
          :max="100"
          v-model="progressValue"
          @input="printProgressValue"
        ></el-slider>
        <i @click="add()" class="el-icon-zoom-in"></i>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { fabric } from "fabric";
import FileSaver from "file-saver";
import "./index.css";
let defaultProps = {
  canvasWidth: {
    type: Number,
    default: window.innerWidth,
  },
  canvasHeight: {
    type: Number,
    default: window.innerHeight,
  },
  canvasBgColor: {
    type: String,
    default: "#f6f6f6",
  },
  strokeColor: {
    type: String,
    default: "#f30",
  },
  strokeWidth: {
    type: Number,
    default: 2,
  },
  showTools: {
    type: Boolean,
    default: true,
  },
  placement: {
    type: String,
    default: "bottom",
  },
};

const TOOLS = [
  {
    name: "铅笔",
    type: "pencil",
    icon: "icon-pan_icon",
  },
  {
    name: "实线",
    type: "line",
    icon: "icon-xian",
  },
  {
    name: "虚线",
    type: "dashedLine",
    icon: "icon-xian1",
  },
  {
    name: "箭头",
    type: "arrow",
    icon: "icon-jiantou",
  },
  {
    name: "文字",
    type: "text",
    icon: "icon-wenzi",
  },
  {
    name: "矩形",
    type: "rect",
    icon: "icon-juxing",
  },
  {
    name: "圆形",
    type: "cricle",
    icon: "icon-yuanxing",
  },
  {
    name: "椭圆形",
    type: "ellipse",
    icon: "icon-tuoyuanxing",
  },
  {
    name: "三角形",
    type: "equilateral",
    icon: "icon-sanjiaoxing",
  },
  {
    name: "上传",
    type: "upload",
    icon: "icon-seiyw41",
  },
  {
    name: "橡皮",
    type: "rubber",
    icon: "icon-xiangpi",
  },
  {
    name: "回退",
    type: "undo",
    icon: "icon-undo",
  },
  {
    name: "向前",
    type: "redo",
    icon: "icon-redo",
  },
  {
    name: "清除",
    type: "clear",
    icon: "icon-clear",
  },
  {
    name: "移动",
    type: "move",
    icon: "icon-yidong",
  },
  {
    name: "下载",
    type: "download",
    icon: "icon-xiazai",
  },
];

export default {
  name: "FabricBoard",
  data() {
    return {
      slideShow: false,
      scale: {},
      imgWidth: "",
      imgHeight: "",
      progressValue: 1,
      boardObj: null, // 存储当前画布对象
      mouseFrom: {}, // 鼠标按下的位置
      mouseTo: {}, // 鼠标抬起的位置
      toolType: "pencil", // 当前工具类型
      isDrawing: false, // 是否正在画 鼠标按下和抬起的开关控制
      drawingObj: null, // 正在绘制的对象
      history: [], // 存放历史记录
      textObj: null, // 存储文字对象
      stage: 0,
      currImg: "",
      tools: TOOLS,
      historyMap: {},
      boardPage: 1,
      boardCount: 1,
      emptyBoardJson: {},
      boardId: undefined,
    };
  },
  props: defaultProps,
  mounted() {
    this.boardObj = new fabric.Canvas("myCanvas", {
      freeDrawingCursor: "grabbing",
      // freeDrawingCursor: 'url(https://www.baidu.com/img/flexible/logo/pc/result.png), pointer',
      // freeDrawingCursor: `url(img)`,
      isDrawingMode: true, // 是否可以自由绘制
      selectable: false, // 控件不能被选择
      selection: true, // 画板中是否显示选中
      devicePixelRatio: true,
    });
    this.boardObj.freeDrawingBrush.color = this.strokeColor; // 设置自由画笔的颜色
    this.boardObj.freeDrawingBrush.width = this.strokeWidth; // 自由画笔的宽度
    this.boardObj.setWidth(this.canvasWidth);
    this.boardObj.setHeight(this.canvasHeight);
    this.initEvent();
    this.emptyBoardJson = JSON.stringify(this.boardObj);
  },
  methods: {
    initEvent() {
      this.boardObj.on({
        "mouse:down": (e) => {
          // console.log('down', e)
          let { x, y } = e.pointer;
          this.mouseFrom = { x, y };
          // 判断是否选中了对象
          if (!this.boardObj.getActiveObject()) {
            this.isDrawing = true;
          }
          if (this.toolType === "text") {
            this.drawText();
          }
        },
        "mouse:up": (e) => {
          // 鼠标抬起
          this.slideShow = false;
          // console.log(this.boardObj.getActiveObject());
          let { x, y } = e.pointer;
          this.mouseTo = { x, y };
          this.isDrawing = false;
          this.drawingObj = null;
          if (this.toolType != "rubber") {
            this.addHistory();
          }
          if (this.toolType == "rubber") {
            this.boardObj.selection = true;
            this.boardObj.skipTargetFind = false;
            this.boardObj.selectable = true;
            if (e.selected && e.selected.length > 0 && e.selected.length < 2) {
              console.log("e.selected", e.selected);
              this.boardObj.remove(e.selected);
              this.addHistory();
            }
          }
          if (this.toolType == "move") {
            this.slideShow = true;
          }
        },
        "mouse:move": (e) => {
          if (this.isDrawing) {
            let { x, y } = e.pointer;
            this.mouseTo = { x, y };
            this.drawing();
          }
        },
        // 移动对象时触发该事件
        "object:moving": (e) => {
          console.log("移动", e);
        },
        // 放大或者缩小对象时触发该事件
        "object:scaling": (e) => {
          console.log("放大缩小", e);
        },
        // 旋转对象时触发该事件
        "object:rotating": (e) => {
          console.log("旋转", e);
        },
        "selection:updated": (e) => {
          // 选中对象时触发该事件
          this.progressValue = Math.floor(
            (e.selected[0].width / window.innerWidth) *
              e.selected[0].scaleX *
              100
          );
          if (this.toolType === "rubber" && e.selected) {
            if (e.selected) {
              var etCount = e.selected.length;
              for (var i = 0; i < etCount; i++) {
                console.log("e.selected1", e.selected);
                this.boardObj.remove(e.selected[i]);
              }
            } else {
              // 单选删除
              this.boardObj.remove(e.selected);
            }
            this.boardObj.discardActiveObject(); // 移除选中样式
            this.addHistory();
          }
          if (this.toolType === "rubber" && !e.selected) {
            this.boardObj.selection = true;
            this.boardObj.skipTargetFind = false;
            this.boardObj.selectable = true;
            // this.boardObj.discardActiveObject()
          }
        },
        "selection:created": (e) => {
          // 选中对象时触发该事件
          this.progressValue = Math.floor(
            (e.selected[0].width / window.innerWidth) *
              e.selected[0].scaleX *
              100
          );
          if (this.toolType === "rubber" && e.selected) {
            if (e.selected) {
              var etCount = e.selected.length;
              for (var i = 0; i < etCount; i++) {
                console.log("e.selected2", e.selected);
                if (e.selected[i].key != "baseImg") {
                  this.boardObj.remove(e.selected[i]);
                }
                // this.boardObj.remove(e.selected[i]);
              }
            } else {
              // 单选删除
              this.boardObj.remove(e.selected);
            }
            this.boardObj.discardActiveObject(); // 移除选中样式
            this.addHistory();
          }
          if (this.toolType === "rubber" && !e.selected) {
            this.boardObj.selection = true;
            this.boardObj.skipTargetFind = false;
            this.boardObj.selectable = true;
            // this.boardObj.discardActiveObject()
          }
        },
      });
    },
    drawing() {
      // 判断是否是同一次绘制 是的话先清楚保留最后一次
      if (this.drawingObj) {
        this.boardObj.remove(this.drawingObj);
      }
      this.boardObj.isDrawingMode = false;
      this.boardObj.selectable = false;
      this.boardObj.selection = false;
      let drawObj = null;
      switch (this.toolType) {
        case "pencil":
          this.boardObj.isDrawingMode = true;
          break;
        case "line":
          drawObj = this.drawLine();
          break;
        case "dashedLine":
          drawObj = this.drawDashedLine();
          break;
        case "arrow":
          drawObj = this.drawArrow();
          break;
        case "rect":
          drawObj = this.drawRect();
          break;
        case "cricle":
          drawObj = this.drawCricle();
          break;
        case "ellipse":
          drawObj = this.drawEllipse();
          break;
        case "equilateral":
          drawObj = this.drawEquilateral();
          break;
        case "move":
          this.boardObj.skipTargetFind = false;
          break;
        default:
          drawObj = null;
          this.boardObj.selection = true;
          this.boardObj.skipTargetFind = true;
          this.boardObj.selectable = true;
          break;
      }
      if (drawObj) {
        console.log(drawObj);
        this.boardObj.add(drawObj);
        this.drawingObj = drawObj;
      }
    },
    // 选择工具
    changeTool(type) {
      console.log("pencil");
      this.boardObj.isDrawingMode = false;
      this.resetDrawObj();
      // 如果有选中的对象先清除选中
      if (this.boardObj.getActiveObject()) {
        this.boardObj.discardActiveObject();
        this.boardObj.renderAll();
      }
      if (type === "clear") {
        this.boardObj.getObjects().forEach((obj) => {
          if (obj.key !== "baseImg") {
            this.boardObj.remove(obj);
          }
        });
        this.boardObj.renderAll();
        // return this.boardObj.clear();
      }
      if (type === "upload") {
        return;
      }
      if (type === "undo") {
        return this.undo();
      }
      if (type === "redo") {
        return this.redo();
      }
      if (type === "download") {
        return this.composeImg();
      }
      this.toolType = type;
      if (type === "pencil") {
        this.boardObj.isDrawingMode = true;
      }
      if (type === "rubber" || type === "move") {
        this.boardObj.selection = true;
        this.boardObj.skipTargetFind = false;
        this.boardObj.selectable = true;
      }
    },
    resetDrawObj() {
      this.boardObj.selectable = true;
      this.boardObj.selection = true;
      this.boardObj.skipTargetFind = true;
      this.isDrawing = false;
      if (this.textObj) {
        this.textObj.exitEditing();
        this.textObj = null;
      }
    },
    // 画实线
    drawLine() {
      return new fabric.Line(
        [this.mouseFrom.x, this.mouseFrom.y, this.mouseTo.x, this.mouseTo.y],
        {
          stroke: this.strokeColor,
          strokeWidth: this.strokeWidth,
        }
      );
    },
    // 画虚线
    drawDashedLine() {
      return new fabric.Line(
        [this.mouseFrom.x, this.mouseFrom.y, this.mouseTo.x, this.mouseTo.y],
        {
          stroke: this.strokeColor,
          strokeWidth: this.strokeWidth,
          strokeDashArray: [10, 3],
        }
      );
    },
    // 画矩形
    drawRect() {
      return new fabric.Rect({
        left: this.mouseFrom.x,
        top: this.mouseFrom.y,
        height: Math.abs(this.mouseTo.y - this.mouseFrom.y),
        width: Math.abs(this.mouseTo.x - this.mouseFrom.x),
        stroke: this.strokeColor,
        strokeWidth: this.strokeWidth,
        fill: "rgba(255, 255, 255, 0)",
      });
    },
    // 画圆形
    drawCricle() {
      // 计算半径 勾股定理  a^2 + b^2 = c^2
      let a = this.mouseTo.x - this.mouseFrom.x;
      let b = this.mouseTo.y - this.mouseFrom.y;
      let r = Math.sqrt(Math.pow(a, 2) + Math.pow(b, 2)) / 2;
      return new fabric.Circle({
        left: this.mouseFrom.x,
        top: this.mouseFrom.y,
        stroke: this.strokeColor,
        fill: "rgba(255, 255, 255, 0)",
        radius: r,
        strokeWidth: this.strokeWidth,
      });
    },
    // 画椭圆
    drawEllipse() {
      let left = this.mouseFrom.x;
      let top = this.mouseFrom.y;
      return new fabric.Ellipse({
        left: left,
        top: top,
        stroke: this.strokeColor,
        fill: "rgba(255, 255, 255, 0)",
        originX: "center",
        originY: "center",
        rx: Math.abs(left - this.mouseTo.x),
        ry: Math.abs(top - this.mouseTo.y),
        strokeWidth: this.strokeWidth,
      });
    },
    // 画等边三角形
    drawEquilateral() {
      let height = this.mouseTo.y - this.mouseFrom.y;
      return new fabric.Triangle({
        top: this.mouseFrom.y,
        left: this.mouseFrom.x,
        width: Math.sqrt(Math.pow(height, 2) + Math.pow(height / 2, 2)),
        height: height,
        stroke: this.strokeColor,
        strokeWidth: this.strokeWidth,
        fill: "rgba(255,255,255,0)",
      });
    },
    // 画箭头
    drawArrow() {
      let [sx, sy] = [this.mouseFrom.x, this.mouseFrom.y];
      let [ex, ey] = [this.mouseTo.x, this.mouseTo.y];
      let disY = sy - ey;
      let disX = sx - ex;
      let theta = 30;
      let headlen = 30;
      var angle = (Math.atan2(disY, disX) * 180) / Math.PI;
      var angle1 = ((angle + theta) * Math.PI) / 180;
      var angle2 = ((angle - theta) * Math.PI) / 180;
      var topX = headlen * Math.cos(angle1);
      var topY = headlen * Math.sin(angle1);
      var botX = headlen * Math.cos(angle2);
      var botY = headlen * Math.sin(angle2);
      var arrowX = sx - topX;
      var arrowY = sy - topY;
      var path = " M " + sx + " " + sy;
      path += " L " + ex + " " + ey;
      arrowX = ex + topX;
      arrowY = ey + topY;
      path += " M " + arrowX + " " + arrowY;
      path += " L " + ex + " " + ey;
      arrowX = ex + botX;
      arrowY = ey + botY;
      path += " L " + arrowX + " " + arrowY;
      return new fabric.Path(path, {
        stroke: this.strokeColor,
        fill: "rgba(255,255,255,0)",
        strokeWidth: this.strokeWidth,
      });
    },
    drawText() {
      let { x, y } = this.mouseFrom;
      this.textObj = new fabric.Textbox("", {
        left: x,
        top: y,
        width: "",
        height: "",
        fill: this.strokeColor,
        hasControls: true,
      });
      this.boardObj.add(this.textObj);
      this.textObj.enterEditing();
      this.textObj.hiddenTextarea.focus();
      this.addHistory();
    },
    // 增加历史记录
    addHistory() {
      // console.log(this.history);
      this.history.push(JSON.stringify(this.boardObj));
    },
    // 撤消
    undo() {
      let stack = this.history;
      // console.log(stack)
      if (this.stage < stack.length) {
        this.boardObj.clear().renderAll();
        this.boardObj.loadFromJSON(stack[stack.length - 1 - this.stage - 1]);
        this.boardObj.renderAll();
        this.stage += 1;
      }
    },
    // 前进
    redo() {
      let stack = this.history;
      if (this.stage > 0) {
        this.boardObj.clear().renderAll();
        this.boardObj.loadFromJSON(stack[stack.length - 1 - this.stage + 1]);
        this.boardObj.renderAll();
        this.stage -= 1;
      }
    },
    // 合成图片并下载
    composeImg() {
      let base64Img = this.boardObj.toDataURL({
        format: "png",
        multiplier: 1,
        quality: 1,
      });
      let bd = base64Img.split(",");
      let mime = bd[0].match(/:(.*?);/)[1];
      let bstr = atob(bd[1]);
      let l = bstr.length;
      let u8arr = new Uint8Array(l);
      while (l--) {
        u8arr[l] = bstr.charCodeAt(l);
      }
      let blobData = new Blob([u8arr], { type: mime });
      console.log("blob", blobData);
      FileSaver.saveAs(blobData, "sketchpad.png");
    },
    uploadImg(e) {
      let imgData = e.target.files[0];
      let reader = new FileReader();
      reader.onload = (res) => {
        let dataUrl = res.target.result;
        let imgObj = new Image();
        imgObj.src = dataUrl;
        imgObj.onload = () => {
          console.log("imgObj", imgObj);
          var oImg = new fabric.Image(imgObj);
          oImg.scale(1);
          this.boardObj.centerObject(oImg).add(oImg).renderAll();
          // 为了连续两次选择同一张图片不触发onchange事件
          this.$refs.sketchpadUpload.value = "";
          this.addHistory();
        };
      };
      reader.readAsDataURL(imgData);
    },
    // 量测左右浮层真实占位，并换算到 fabric 坐标系（避免 CSS 拉伸导致右侧仍被挡）
    getSafeBoardArea() {
      const canvasWidth = this.boardObj.width;
      const canvasHeight = this.boardObj.height;
      const canvasEl =
        this.boardObj.lowerCanvasEl || this.boardObj.getElement();
      const canvasRect = canvasEl
        ? canvasEl.getBoundingClientRect()
        : {
            width: canvasWidth,
            height: canvasHeight,
            left: 0,
            top: 0,
            right: canvasWidth,
          };
      // CSS 像素 → fabric 坐标
      const sx = canvasRect.width ? canvasWidth / canvasRect.width : 1;
      const sy = canvasRect.height ? canvasHeight / canvasRect.height : 1;

      const toolEl = this.$el && this.$el.querySelector(".tool-box");
      const rightEl = document.querySelector(".right-box");

      let leftGutterCss = 50;
      if (toolEl) {
        const rect = toolEl.getBoundingClientRect();
        leftGutterCss = Math.min(Math.ceil(rect.width) || 50, 120);
      }
      // 工具栏旁少留一点空隙，避免左边太空
      leftGutterCss = Math.max(44, leftGutterCss);

      let rightGutterCss = 232;
      if (rightEl) {
        const rect = rightEl.getBoundingClientRect();
        // 按画布右边缘到右侧栏左边缘的实际遮挡宽度计算
        const overlap = Math.max(0, canvasRect.right - rect.left);
        rightGutterCss = Math.ceil(overlap || rect.width) || 232;
      }
      // 右侧多留安全边，消除“还差一点被挡”
      rightGutterCss += 28;

      const leftGutter = leftGutterCss * sx;
      const rightGutter = rightGutterCss * sx;
      const topPad = 8 * sy;
      const bottomPad = 36 * sy;
      const availableWidth = Math.max(1, canvasWidth - leftGutter - rightGutter);
      const availableHeight = Math.max(1, canvasHeight - topPad - bottomPad);

      return {
        leftGutter,
        rightGutter,
        topPad,
        bottomPad,
        availableWidth,
        availableHeight,
        canvasWidth,
        canvasHeight,
      };
    },
    addImage(image, top, key) {
      if (key === "baseImg") {
        this.boardObj.clear().renderAll();
        this.toolType = "pencil";
      }
      console.log(image);
      let that = this;
      top = !top ? 88 : top;
      this.boardObj.isDrawingMode = false;
      this.resetDrawObj();
      // 如果有选中的对象先清除选中
      if (this.boardObj.getActiveObject()) {
        this.boardObj.discardActiveObject();
        this.boardObj.renderAll();
      }
      var xhr = new XMLHttpRequest();
      xhr.open("get", image.url, true);
      xhr.responseType = "blob";
      xhr.onload = function () {
        console.log(xhr.status);
        console.log(xhr.response);
        if (xhr.status === 200) {
          let imgObj = new Image();
          imgObj.src = URL.createObjectURL(xhr.response);
          imgObj.onload = () => {
            console.log("imgObj111", imgObj);

            const area = that.getSafeBoardArea();
            const scale = Math.min(
              1,
              area.availableWidth / imgObj.width,
              area.availableHeight / imgObj.height
            );
            const displayW = imgObj.width * scale;
            const displayH = imgObj.height * scale;

            let oImg = new fabric.Image(imgObj);
            oImg.key = key;
            oImg.scale(scale);
            // 靠左摆放，减少工具栏右侧空白；右侧已用 gutter 避开遮挡
            oImg.left = area.leftGutter + 4;
            oImg.top =
              area.topPad + Math.max(0, (area.availableHeight - displayH) / 2);
            that.boardObj.add(oImg).renderAll();
            // 为了连续两次选择同一张图片不触发onchange事件
            that.$refs.sketchpadUpload.value = "";
            that.addHistory();
            that.boardObj.isDrawingMode = true;
          };
        }
      };
      xhr.send();
    },
    // getBoardObj () {
    //   return this.historyMap[this.boardId][this.pageNum]
    // },

    addImages(images) {
      this.boardObj.isDrawingMode = false;
      this.resetDrawObj();
      if (this.boardObj.getActiveObject()) {
        this.boardObj.discardActiveObject();
        this.boardObj.renderAll();
      }
      if (!images || images.length === 0) {
        return;
      }

      const GAP = 8;
      const area = this.getSafeBoardArea();
      const that = this;

      // 全部加载完成后再统一按 contain 布局，避免异步改写共享宽度
      const loadTasks = images.map((image) => {
        return new Promise((resolve) => {
          const imgObj = new Image();
          imgObj.onload = () => {
            resolve(imgObj);
          };
          imgObj.onerror = () => {
            resolve(null);
          };
          imgObj.src = image.url;
        });
      });

      Promise.all(loadTasks).then((loadedImgs) => {
        const validImgs = loadedImgs.filter((img) => img);
        if (validImgs.length === 0) {
          that.boardObj.isDrawingMode = true;
          return;
        }

        const totalGaps = GAP * (validImgs.length - 1);
        const slotWidth = Math.max(
          1,
          (area.availableWidth - totalGaps) / validImgs.length
        );

        const layouts = validImgs.map((imgObj) => {
          const scale = Math.min(
            slotWidth / imgObj.width,
            area.availableHeight / imgObj.height
          );
          return {
            imgObj,
            scale,
            w: imgObj.width * scale,
            h: imgObj.height * scale,
          };
        });

        let startLeft = area.leftGutter + 4;

        layouts.forEach((item) => {
          const oImg = new fabric.Image(item.imgObj);
          oImg.scale(item.scale);
          oImg.left = startLeft;
          oImg.top = (area.canvasHeight - item.h) / 2;
          that.boardObj.add(oImg);
          startLeft += item.w + GAP;
        });

        that.boardObj.renderAll();
        if (that.$refs.sketchpadUpload) {
          that.$refs.sketchpadUpload.value = "";
        }
        that.addHistory();
        that.boardObj.isDrawingMode = true;
      });
    },
    printProgressValue() {
      let activeObject = this.boardObj.getActiveObject();
      if (activeObject && activeObject.type === "image") {
        let cacheKey = activeObject.cacheKey;
        this.slideShow = true;
        var aa = (this.progressValue / 100) * window.innerWidth;
        var bb = aa / activeObject.width;
        if (bb > this.scale[cacheKey]) {
          activeObject.top =
            activeObject.top -
            ((bb - this.scale[cacheKey]) * activeObject.height) / 2;
          activeObject.left =
            activeObject.left -
            ((bb - this.scale[cacheKey]) * activeObject.width) / 2;
        }
        if (bb < this.scale[cacheKey]) {
          activeObject.top =
            activeObject.top +
            ((this.scale[cacheKey] - bb) * activeObject.height) / 2;
          activeObject.left =
            activeObject.left +
            ((this.scale[cacheKey] - bb) * activeObject.width) / 2;
        }
        this.scale[cacheKey] = bb;
        activeObject.scaleX = bb;
        activeObject.scaleY = bb;
        this.boardObj.renderAll();
      }
      if (!activeObject || activeObject.type !== "image") {
        this.progressValue = 0;
      }
    },

    add() {
      this.progressValue = this.progressValue + 5;
    },
    less() {
      this.progressValue = this.progressValue - 5;
    },
    switchBoard(boardId, pageNum) {
      this.boardId = boardId;
      this.pageNum = pageNum;
      if (!this.historyMap[boardId]) {
        this.historyMap[boardId] = {};
      }
      if (!this.historyMap[boardId][pageNum]) {
        this.historyMap[boardId][pageNum] = [];
        this.historyMap[boardId][pageNum].push(
          JSON.stringify(this.emptyBoardJson)
        );
      }
      this.history = this.historyMap[this.boardId][this.pageNum];
      // console.log(this.history)
      this.boardObj.clear().renderAll();
      this.boardObj.loadFromJSON(this.history[this.history.length - 1]);
      this.boardObj.renderAll();
      if (this.toolType !== "pencil") {
        this.boardObj.isDrawingMode = false;
        this.isDrawing = false;
      }
    },
  },
};
</script>
<style scoped lang="">
.board-box {
  position: fixed;
  bottom: 0;
}
@media (max-width: 1000px) {
  /* 在屏幕宽度小于或等于 1000 像素时应用的样式 */
  .toolList {
    display: flex;
    /* flex-direction: column; */
    flex-wrap: wrap;
    width: 100px !important;
    height: 50vh !important;
  }
  .slide-minwidtg {
    left: 103px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/explain/FabricBoard.vue